/**
 * This file contains logic specific to a template.
 * It is intended to ONLY be loaded on templates that require
 * this specific functionality.
 **/

import Logger from './lib/logger';
import './partials/BundlerState';
import './partials/CustomBundle';
import './partials/BundlerSideCart';
import './partials/SideCartContainerTitle';
import './partials/BundlerModal';
import './partials/NumberButton';
import './partials/BundlerStep';
import './partials/HowItWorksModal';
import './partials/ExitModal';
import './partials/ProductModal';
import './partials/MultiModal';
import './partials/ProductCard';
import './partials/CustomTextRadioGroup';
import './partials/CustomTextInput';
import './partials/MultipleUpdater';
import './partials/ProductForm';
import './partials/ExtendedWarranty';
import './partials/TabComponent';
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

const NAME = 'Bundler JS';

// Logic
// ▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒▒

Logger.info(`${NAME} > loaded`);
